module.exports = __webpack_public_path__ + "img/ELIX.6bc49d42.svg";